import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppSettingsDto } from "../../services/api.services";
import { LocalisationService } from "../../services/localisation.service";
import { SettingsDrivenPipeOverride } from "./settings-driven-pipe-override";

/* Same as 'date' but assumes the given value is already in the user's time zone */

@Pipe({
  name: 'localDate',
  pure: false,
  standalone: false
})
export class LocalDatePipe extends SettingsDrivenPipeOverride<DatePipe> implements PipeTransform {
  protected getPipe() {
    return new DatePipe(this.pipeLocale);
  }

  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, locale?: string) {
    let formatString = this.localisationService.CUSTOM_DATE_FORMATS[format] || format;
    const locale_ = locale ?? settings.locale ?? this.pipeLocale;

    if (locale_.toLowerCase() === 'ja-JP'.toLowerCase()) {
      formatString = this.localisationService.mapToJapaneseFormat(formatString);
    }

    return pipe.transform(value, formatString, null, locale_);
  }
}
